import TrapInviteVerify from './TrapInviteVerify'
import enhance from './TrapInviteVerify.enhancer'

export default enhance(TrapInviteVerify)



// WEBPACK FOOTER //
// ./src/containers/invitations/TrapInviteVerify/index.js